// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { MDXProvider } from '@mdx-js/react';

// import types
import { FixMeLater } from '../../types';

// import components
import MarkdownImage from './MarkdownImage';
import MarkdownLink from './MarkdownLink';

// import styles
import styles from './Markdown.module.css';

// define component
const LocalMarkdown: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className={styles['markdown']}>
      <MDXProvider
        components={
          {
            StorylinerImage: MarkdownImage,
            a: MarkdownLink,
          } as FixMeLater
        }
      >
        {children}
      </MDXProvider>
    </div>
  );
};

LocalMarkdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LocalMarkdown;
